module.exports = __webpack_public_path__ + "pc/img/modal_12.13b42f1e.png";